// Which puzzles exist to be played again: every daily that has run and every
// Call Sheet in the pool, most recent first (`archive_list`). With the test
// code, everything queued, so the archive can be tried before launch.
//
// Read by the Archive window, fresh each time it opens, and by a result
// screen's "the most recent daily you have not played" button.
import { rpc } from './api.ts';

export interface ArchiveListing { runningOrder: number[]; callSheet: number[]; test: boolean }

export function archiveList(): Promise<ArchiveListing> {
  return rpc<ArchiveListing>('archive_list', {});
}

/** Whether a puzzle by this number was withdrawn after it was published, for a
 *  share link that arrives at one. False when the question cannot be asked. */
export function wasWithdrawn(game: 'running-order' | 'call-sheet', number: number): Promise<boolean> {
  return rpc<boolean>('puzzle_withdrawn', { p_game: game, p_number: number }).catch(() => false);
}
